import { render, staticRenderFns } from "./pageTypeRule.vue?vue&type=template&id=ba0a2b52"
import script from "./pageTypeRule.vue?vue&type=script&lang=js"
export * from "./pageTypeRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports